import Request from 'core/api/Request';
import urlResolver from 'edrolo/utils/URLResolver';

const ShortLinkAPI = {
  create(appLabel, model, objectId, queryString) {
    const data = {
      content_type: `${appLabel}.${model}`,
      object_id: objectId,
      query_string: queryString,
    };

    return Request.post(urlResolver.getPath('api:post:short-link'))
      .send(data)
      .end();
  },
};

export default ShortLinkAPI;
